import React from 'react';
import styled from 'styled-components';
import useCookiePolicy from '../../hooks/flags/useCookiePolicy';

const ControllsAreaContainer = styled.div<{ withBottomPadding: boolean }>`
    padding-bottom: ${({ withBottomPadding }) => (withBottomPadding ? '67px' : '15px')};
`;

const ControllsArea: React.FC = ({ children }) => {
    const { isAccepted } = useCookiePolicy();
    return <ControllsAreaContainer withBottomPadding={!isAccepted}>{children}</ControllsAreaContainer>;
};

export default ControllsArea;
